'use client';

import React from 'react';
import { Trash2 } from 'lucide-react';
import { alpha } from "@mui/material/styles";
import { Box, Button, Typography } from "@mui/material";

interface DocumentBulkActionsProps {
  selectedCount: number;
  documentType: 'invoice' | 'quote';
  onClearSelection: () => void;
  onBulkDelete: () => void;
  isDeleting?: boolean;
}

export function DocumentBulkActions({
  selectedCount,
  documentType,
  onClearSelection,
  onBulkDelete,
  isDeleting = false
}: DocumentBulkActionsProps) {
  if (selectedCount === 0) return null;

  const documentLabel = documentType === 'quote' ? 'quote' : 'invoice';
  const documentLabelPlural = documentType === 'quote' ? 'quotes' : 'invoices';

  return (
    <Box
      sx={{
        mb: 2,
        p: 1.5,
        bgcolor: (t) => alpha(t.palette.primary.main, 0.12),
        border: 1,
        borderColor: (t) => alpha(t.palette.primary.main, 0.3),
        borderRadius: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography component="span" sx={{ fontSize: 14, fontWeight: 500, color: "primary.main" }}>
            {selectedCount} {selectedCount === 1 ? documentLabel : documentLabelPlural} selected
          </Typography>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={onClearSelection}
          >
            Clear Selection
          </Button>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={onBulkDelete}
            disabled={isDeleting}
            startIcon={<Trash2 size={16} />}
          >
            Delete Selected
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
